export { LoyaltyHomeContainer } from './LoyaltyHomeContainer';
